import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Col,
         Grid,
         Row } from 'react-bootstrap';

const iconUser = require('../assets/img/icon_user.png');
const logo = require('../assets/img/logo.png');

class MainMenu extends Component {
    render() {
        return (
            <Grid fluid>
              <Row className="genode-header">
                <Col xs={2}>
                  <img src={logo} className="App-logo" alt="logo" />
                </Col>
                <Col xs={2} xsOffset={8}>
                  <img src={iconUser} className="icon-user" alt="User icon" /><span className="App-title">Hi, Dr.xxx xxxx</span>
                </Col>
              </Row>
              <br/>
              <div align='center'>
                  <h1>Test Menu</h1>
              </div>
              <br/>
              <div align='center'>
                  <Link to="/login">Login</Link>
              </div>
              <br/>
              <div align='center'>
                  <Link to="/resultlist">ResultList</Link>
              </div>
            </Grid>
        );
    }

}

export default MainMenu;



// WEBPACK FOOTER //
// ./src/components/MainMenu.js